export default __webpack_public_path__ + "static/media/gambar-19.c530eb54.png";